import { InvoiceAddressDto } from "packages/libs/shared-models/src/common/Addres/address-dto";
import { CommonAxiosService } from "../common-axios-service-prs";
import { CommonResponseModel } from '@project-management-system/shared-models';


export class AddressService extends CommonAxiosService{
URL = '/address';

        async createAddress(req: InvoiceAddressDto): Promise<CommonResponseModel> {
            return this.axiosPostCall(this.URL +  '/createAddress',req)
        }

        async  updateAddress(req: InvoiceAddressDto): Promise<CommonResponseModel> {
            return this.axiosPostCall(this.URL + '/updateAddress', req)
        }
        
        async getAllAddress(): Promise<CommonResponseModel> {
            return this.axiosPostCall(this.URL + "/getAllAddress")
        }
        
        async  activateOrDeactivateAddress(req: InvoiceAddressDto): Promise<CommonResponseModel> {
            return this.axiosPostCall(this.URL + '/activateOrDeactivateAddress', req)
        }
        
        async  getAllActiveAddress(): Promise<CommonResponseModel> {
            return this.axiosPostCall(this.URL + '/getAllActiveAddress')
        }        

}